// The COMP row amounts and the BIR Form 1601-C (January 2018 ENCS) items
// they feed. Shared by the compensation grid, the edit modal and the CSV
// preview. `mwe`: 'only' = minimum wage earners only; 'not' = non-MWEs only.
// Labels follow the form; check them against docs/bir-forms/ (not in the repo).

export const COMP_FIELDS = [
  { key: "totalCompCentavos", item: "14", label: "Total Amount of Compensation" },
  { key: "mweSmwCentavos", item: "15", label: "Statutory Minimum Wage (for Minimum Wage Earners (MWEs))", mwe: "only" },
  { key: "mweHolidayOtNdHazardCentavos", item: "16", label: "Holiday Pay, Overtime Pay, Night Shift Differential Pay, Hazard Pay (for MWEs)", mwe: "only" },
  { key: "thirteenthMonthCentavos", item: "17", label: "13th Month Pay and Other Benefits" },
  { key: "deMinimisCentavos", item: "18", label: "De Minimis Benefits" },
  { key: "contributionsCentavos", item: "19", label: "SSS, GSIS, PHIC, HDMF Mandatory Contributions and Union Dues (employee's share only)" },
  { key: "otherNonTaxableCentavos", item: "20", label: "Other Non-Taxable Compensation (specify)" },
  { key: "notSubjectCentavos", item: "23", label: "Taxable Compensation Not Subject to Withholding Tax (for employees, other than MWEs, receiving ₱250,000 & below for the year)", mwe: "not" },
  { key: "taxWithheldCentavos", item: "25", label: "Total Taxes Withheld" },
];

/** The expanded-row fields (items 15–20 and 23). */
export const DETAIL_FIELDS = COMP_FIELDS.filter((f) => !["totalCompCentavos", "taxWithheldCentavos"].includes(f.key));

/** Is this field usable for the employee? (15/16 MWE only; 23 non-MWE only.) */
export const fieldEnabledFor = (field, employee) => {
  if (!employee) return true;
  if (field.mwe === "only") return Boolean(employee.isMwe);
  if (field.mwe === "not") return !employee.isMwe;
  return true;
};

export const CSV_TEMPLATE_HEADER =
  "employee_tin,last_name,first_name,middle_name,month,total_comp,mwe_smw,mwe_holiday_ot_nd_hazard,thirteenth_month,de_minimis,contributions,other_nontaxable,other_nontaxable_specify,not_subject,tax_withheld";
